/* EYESHELLS 1661: product sticky controls, one cancellable frame per update. */
(function (w, d) {
  'use strict';
  var previous = w.__esStickyUiState;
  if (previous && typeof previous.cleanup === 'function') previous.cleanup();
  var sticky = null;
  var header = null;
  var frame = 0;
  var active = null;
  var headerHeight = -1;
  var measure = true;
  var mounted = false;
  var destroyed = false;
  var resizeObserver = null;

  function isProduct() { return !!(d.body && d.body.classList.contains('template-product')); }
  function refreshNodes() {
    sticky = d.querySelector('.sticky_addcart');
    header = d.querySelector('#shopify-section-header') || d.querySelector('header,.site-header,.header');
    active = null;
    measure = true;
    if (resizeObserver) {
      resizeObserver.disconnect();
      if (header) resizeObserver.observe(header);
    }
  }
  function render() {
    frame = 0;
    if (destroyed || !mounted || !isProduct()) return;
    if ((sticky && !sticky.isConnected) || (header && !header.isConnected)) refreshNodes();
    // Finish layout reads before changing the sticky class or CSS variable.
    var nextHeight = headerHeight;
    if (measure && header && header.isConnected) {
      nextHeight = Math.round(header.getBoundingClientRect().height || header.offsetHeight || 0);
    }
    measure = false;
    var width = w.innerWidth || d.documentElement.clientWidth || 1024;
    var y = w.pageYOffset || d.documentElement.scrollTop || 0;
    var nextActive = y >= (width > 1024 ? 100 : 300);
    if (nextHeight > 0 && nextHeight !== headerHeight) {
      headerHeight = nextHeight;
      d.documentElement.style.setProperty('--es-header-h', nextHeight + 'px');
    }
    if (sticky && nextActive !== active) {
      active = nextActive;
      sticky.classList.toggle('active', active);
    }
  }
  function schedule() {
    if (destroyed || !mounted || frame) return;
    frame = w.requestAnimationFrame(render);
  }
  function onResize() { measure = true; schedule(); }
  function onSection() { if (!mounted) return; refreshNodes(); schedule(); }
  function cancelFrame() {
    if (frame) w.cancelAnimationFrame(frame);
    frame = 0;
  }
  function suspend() {
    mounted = false;
    cancelFrame();
    if (resizeObserver) resizeObserver.disconnect();
    w.removeEventListener('scroll', schedule);
    w.removeEventListener('resize', onResize);
    d.removeEventListener('shopify:section:load', onSection);
    d.removeEventListener('shopify:section:unload', onSection);
  }
  function resume() {
    if (destroyed || mounted || !isProduct()) return;
    mounted = true;
    refreshNodes();
    w.addEventListener('scroll', schedule, { passive: true });
    w.addEventListener('resize', onResize, { passive: true });
    d.addEventListener('shopify:section:load', onSection);
    d.addEventListener('shopify:section:unload', onSection);
    schedule();
  }
  if (w.ResizeObserver) resizeObserver = new w.ResizeObserver(onResize);
  w.addEventListener('pagehide', suspend);
  w.addEventListener('pageshow', resume);
  w.__esStickyUiState = {
    cleanup: function () {
      destroyed = true;
      suspend();
      w.removeEventListener('pagehide', suspend);
      w.removeEventListener('pageshow', resume);
    }
  };
  resume();
})(window, document);
